import { RouteItems } from 'sitemap';
import { UserRole } from 'store/authSlice';

export const filterRoutesByRole = (
  routes: RouteItems[],
  userRole: UserRole
): RouteItems[] => {
  return routes
    .map(routeGroup => {
      const filteredPages = routeGroup.pages
        .filter(page => {
          return !page.roles || page.roles.includes(userRole);
        })
        .map(page => {
          if (page.pages) {
            return {
              ...page,
              pages: page.pages.filter(
                child => !child.roles || child.roles.includes(userRole)
              )
            };
          }
          return page;
        });

      if (filteredPages.length === 0) return null;

      return {
        ...routeGroup,
        pages: filteredPages
      };
    })
    .filter(Boolean) as RouteItems[];
};
